import type { ReactNode } from "react";
import { Wordmark } from "../components/Brand.js";

/** Marco de las páginas públicas (ingreso, definir contraseña). */
export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-[400px]">
        <div className="mb-6 flex justify-center">
          <Wordmark />
        </div>
        <main className="rounded-xl border border-border bg-surface px-5 py-6 shadow-card sm:px-7">
          <h1 className="text-lg font-semibold text-fg">{title}</h1>
          {subtitle && <div className="mt-1 text-[13px] text-muted">{subtitle}</div>}
          <div className="mt-5">{children}</div>
        </main>
        <p className="mt-6 text-center text-[12px] text-subtle">
          Herramienta de investigación para instituciones aseguradoras. Acceso solo con cuenta asignada.
        </p>
      </div>
    </div>
  );
}
